import NumberInput from 'components/forms/inputs/rhf-inputs/NumberInput';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import InfoTooltip from 'components/InfoTooltip';
import { useInRecordSection } from 'components/section-edit/SectionEdit';
import { Control, UseFormSetValue } from 'react-hook-form';
import { ClassifierData } from 'types/classifiers';
import { MatterForm } from 'types/matters';
import { getValidOptionsFromClassifier } from 'utils/formUtil';

type Props = {
    control: Control<MatterForm>;
    setValue: UseFormSetValue<MatterForm>;
    classifiers: Record<string, ClassifierData>;
};

export function EstimatedEngagementLengthInput({ control, setValue, classifiers }: Props) {
    // On the record page the amount and its unit are one cell on a row of its own, where the read view has their
    // line, under a label that runs over both rather than wrap in the amount's width.
    const inSection = useInRecordSection();
    return (
        <div
            className={
                inSection
                    ? 'form-field col-span-full flex items-end gap-6'
                    : 'flex flex-col gap-2 sm:flex-row sm:items-end'
            }
        >
            <div className={inSection ? 'min-w-0 flex-1 [&_label]:whitespace-nowrap' : 'flex-1'}>
                <NumberInput
                    control={control}
                    name="estimatedEngagementLength"
                    label="matters.estimated-engagement-length"
                    tooltip={<InfoTooltip text="matters.estimated-engagement-length-tooltip" />}
                    placeholder="e.g. 6"
                    shouldTranslatePlaceholder={false}
                    inputProps={{ min: 0 }}
                />
            </div>
            <div className="flex-1">
                <SelectInput
                    control={control}
                    setValue={setValue}
                    name="estimatedEngagementUnit"
                    options={
                        (getValidOptionsFromClassifier(classifiers['ENGAGEMENT_LENGTH_UNIT']) as {
                            label: string;
                            value: string;
                        }[]) ?? []
                    }
                    getOptionLabel="label"
                    getOptionIdentifier="value"
                    clearable={false}
                />
            </div>
        </div>
    );
}
